export function ensureNumber(value: string | number): number;
export function ensureNumber(value: string | number | null): number | null;
export function ensureNumber(value: unknown) {
  if (typeof value === "string") {
    return parseFloat(value.replace(new RegExp(",", "g"), "."));
  } else {
    return value;
  }
}
